export default {
  state: () => ({
    tabInfo: {
      name: '',
      action: null,
    },
  }),
  mutations: {
    UPDATE_TAB_INFO(state, payload) {
      state.tabInfo = payload
    },
    CLEAR_TAB_INFO(state) {
      state.tabInfo = { name: '', action: null }
    },
  },
}
